import { isArrayWithLength } from '../../../utils/common-methods';

/**
 * Extracts the X3 account number value from an account number object or array
 * @param {Object|Array} accountNumberOrArray - Account number object or array of account numbers
 * @returns {string|null} - The X3 account number value or fallback to accountNumber, or null
 */
export const getX3AccountValue = (accountNumberOrArray) => {
  if (!accountNumberOrArray) {
    return null;
  }

  // Handle array case (from accountNumbers array)
  if (isArrayWithLength(accountNumberOrArray)) {
    const account = accountNumberOrArray[0];
    return account?.X3_accountNumber?.trim() || account?.accountNumber || null;
  }

  // Handle object case (from accountNumber object)
  return (
    accountNumberOrArray?.X3_accountNumber?.trim() ||
    accountNumberOrArray?.value ||
    accountNumberOrArray?.name ||
    accountNumberOrArray?.accountNumber ||
    null
  );
};

/**
 * Formats an account number object for use in Autocomplete components
 * Sets id, name, text, and value to the X3 account number value
 * @param {Object|Array} accountNumberOrArray - Account number object or array of account numbers
 * @returns {Object|null} - Formatted account number object or null
 */
export const formatAccountNumberForAutocomplete = (accountNumberOrArray) => {
  if (!accountNumberOrArray) {
    return null;
  }

  // Handle array case
  if (isArrayWithLength(accountNumberOrArray)) {
    const account = accountNumberOrArray[0];
    const x3Value = account?.X3_accountNumber?.trim() || account?.accountNumber;

    if (!x3Value) {
      return null;
    }

    return {
      ...account,
      // Keep the full account object with X3_accountNumber for the modal
      // Use X3_accountNumber for the dropdown value to match Autocomplete options
      id: x3Value,
      name: x3Value,
      text: x3Value,
      value: x3Value,
    };
  }

  // Handle object case
  const x3Value = getX3AccountValue(accountNumberOrArray);

  if (!x3Value) {
    return null;
  }

  return {
    ...accountNumberOrArray,
    id: x3Value,
    name: x3Value,
    text: x3Value,
    value: x3Value,
  };
};
